import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";


import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";

import FormInput from "../../common/form-controls/input";
import FormCheckbox from "../../common/form-controls/checkbox";
import UserProfileRegionComponent from "./user-profile-region";

import { actionSaveUserProfileData } from "../actions";
import { openToaster } from "../../../actions/common";

import { NEW_USER } from "../../../constants/data";

import { CommonConstant } from "src/constants/data";
import { getDuplicateArrayElements, getLoggedInCurrentUserDetails } from "src/utils";
import {
  WarningLabel,
  BigContainer,
  CustomDevider,
  GreenFormControlLabel,
  BlueSubHeader,
  UserContainer,
  AddRoleButton,
  DialogButtonDefault,
  DialogButtonPrimary,
} from "../style";
import FormSelect from "../../common/form-controls/select";
import { accessTypeData, UserRolesList } from "src/constants/dropdown";
import { AccessTypeEnum, UserRoles } from "src/constants/api";

function UserProfileFormComponent(props: any) {
  const {
    editFormValues,
    isEdit,
    showHideTableAndForm,
    roleData,
    listRoles,
    fieldsRegionArray,
    counterRegion,
    setCounterRegion,
    setFieldsRegionArray,
    closeToasterFun,
    //   userId,
    // userName,
    // createdDate,
    // modifiedDate,
  } = props;
  const dispatch = useDispatch();

  const userIdentity = useSelector((state: any) => state.common.userIdentity);

  const [validateSchema, setValidateSchema]: any = useState({});
  const [isDisableAccessFor, setIsDisableAccessFor]: any = useState(false);

  const methods = useForm({
    resolver: yupResolver(validateSchema),
  });

  const {
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = methods;

  const [userStatus, setUserStatus]: any = useState(true);
  const [userStatusLabel, setUserStatusLabel]: any = useState("Active");

  const [isAdminChecked, setIsAdminChecked] = useState(false);
  const [isGuestRoleAdded, setIsGuestRoleAdded] = useState(false);
  const [isRemoveClicked, setIsRemoveClicked] = useState(false);

  const currentUser = useSelector((state: any) => state.home.currentUser);

  let roleSelected: any = [];
  let showMessge: boolean = false;

  useEffect(() => {
    setValidateSchema(
      yup.object().shape({
        firstName: yup
          .string()
          .trim()
          .required("Please enter first name"),
        lastName: yup
          .string()
          .trim()
          .required("Please enter last name"),
        email: yup
          .string()
          .trim()
          .required("Please enter email")
          .email("Please enter valid email"),
        role: yup
          .string()
          .trim()
          .required("Please select role"),
        accessFor: yup
          .string()
          .trim()
          .required("Please select access for"),
      })
    );
  }, []);

  useEffect(() => {
    if (isAdminChecked && fieldsRegionArray && fieldsRegionArray.length === 1) {
      const selectedRole: any = `userRegion[${fieldsRegionArray[0]["counterRegion"]}].role`;
      setValue(selectedRole, fieldsRegionArray[0].setRoleUser.id);
    } else if (
      isRemoveClicked &&
      fieldsRegionArray &&
      fieldsRegionArray.length
    ) {
      fieldsRegionArray.map((fields: any) => {
        if (Object.keys(fields.setRoleUser).length) {
          const selectedRole: any = `userRegion[${fields.counterRegion}].role`;
          setValue(selectedRole, fields.setRoleUser.roleId);
        }
      });
      setIsRemoveClicked(false);
    }
  }, [isAdminChecked, isRemoveClicked]);

  useEffect(() => {
    if (
      editFormValues &&
      Object.keys(editFormValues).length > 1 &&
      editFormValues.hasOwnProperty("id")
    ) {
      const { name, firstName, lastName, emails } = getLoggedInCurrentUserDetails(editFormValues);
      setValue("firstName", firstName);
      setValue("lastName", lastName);
      setValue("email", emails || "");
      setValue("role", editFormValues.roleId);
      setValue("isActive", editFormValues.isActive);

      if (editFormValues.roleId === UserRoles.QMU
        || editFormValues.roleId === UserRoles.INS
        || editFormValues.roleId === UserRoles.Solution_Owner) {
        setIsDisableAccessFor(true);
        setValue("accessFor", AccessTypeEnum.BOTH);
      }
      else {
        setValue("accessFor", editFormValues.accessFor);
        setIsDisableAccessFor(false);
      }
      const userStatus = editFormValues.isActive ? true : false;
      const userStatusLabel = editFormValues.isActive ? "Active" : "Inactive";
      setUserStatusLabel(userStatusLabel);
      setUserStatus(userStatus);

    }
  }, [editFormValues]);

  const onSubmit = (data: any) => {
    let formData: any = {};

    if (editFormValues && editFormValues.id) {
      formData = {
        id: editFormValues.id,
        email: data.email.trim(),
        isActive: userStatus,
        username: data.email.trim(),
        firstName: data.firstName,
        lastName: data.lastName,
        role: Number(data.role),
        accessFor: Number(data.accessFor),
        loggedInUserId: currentUser.id
      };
      dispatch(actionSaveUserProfileData(formData));
    } else {
      formData = {
        userDetailsList: [{
          email: data.email.trim(),
          isActive: userStatus,
          username: data.email.trim(),
          firstName: data.firstName,
          lastName: data.lastName,
          role: Number(data.role),
          accessFor: Number(data.accessFor),
          loggedInUserId: currentUser.id
        }]
      }
      dispatch(actionSaveUserProfileData(formData));
    }
    //reset();
    //showHideTableAndForm(false);
  };

  const callFunctionAddUserRoleMapping = (
    data: any,
    userCountryRoleMappings: any
  ): [] => {
    data.userRegion.forEach((userMapping: any) => {
      if (userMapping && userMapping.role) {
        let roleMap = roleData.filter(
          (role: any) => role.id === userMapping.role
        );

        roleSelected.push(userMapping.role);
        if (
          roleMap &&
          (roleMap[0].name.trim() === NEW_USER.ROLE.ADMIN ||
            roleMap[0].name.trim() === NEW_USER.ROLE.FMC ||
            roleMap[0].name.trim() === NEW_USER.ROLE.INS ||
            roleMap[0].name.trim() === NEW_USER.ROLE.PARTNER ||
            roleMap[0].name.trim() === NEW_USER.ROLE.QMU ||
            roleMap[0].name.trim() === NEW_USER.ROLE.SOLUTION_OWNER ||
            roleMap[0].name.trim() === NEW_USER.ROLE.SOLUTION_TEAM ||
            roleMap[0].name.trim() === NEW_USER.ROLE.UNICEF)
        ) {
          userCountryRoleMappings.push({
            roleId: userMapping.role,
            isDeleted: false,
          });
        }
      } else {
        dispatch(openToaster("Please select role", false));
        closeToasterParticularTimeInterval();
        showMessge = true;
        return;
      }
    });
    return userCountryRoleMappings;
  };

  const callFunctionEditCondition = (
    formData: any,
    userCountryRoleMappings: any
  ): [] => {
    formData.id = editFormValues.id;
    formData.userId = editFormValues.userId;
    let roleEdit: any = [];
    editFormValues.userRoleMapping.map((user: any) => {
      if (!roleEdit.includes(user.roleId)) {
        roleEdit.push(user.roleId);
      }
    });
    if (roleEdit.length) {
      roleSelected.push(roleEdit);
      roleEdit.map((role: any) => {
        let rolename = roleData.filter((roleE: any) => roleE.id === role);
        let userCountry = userCountryRoleMappings.filter(
          (country: any) => country.roleId === role
        );
        if (
          rolename &&
          (rolename[0].name.trim() === NEW_USER.ROLE.ADMIN ||
            rolename[0].name.trim() === NEW_USER.ROLE.FMC ||
            rolename[0].name.trim() === NEW_USER.ROLE.INS ||
            rolename[0].name.trim() === NEW_USER.ROLE.PARTNER ||
            rolename[0].name.trim() === NEW_USER.ROLE.QMU ||
            rolename[0].name.trim() === NEW_USER.ROLE.SOLUTION_OWNER ||
            rolename[0].name.trim() === NEW_USER.ROLE.SOLUTION_TEAM ||
            rolename[0].name.trim() === NEW_USER.ROLE.UNICEF)
        ) {
          if (userCountry.length) {
            userCountry.map((userselect: any) => {
              let editRoleData = editFormValues.userRoleMapping.filter(
                (d: any) => d.roleId === userselect.roleId
              );
              if (editRoleData && editRoleData.length) {
                userselect.id = editRoleData[0].id;
                userselect.userId = editFormValues.id;
              }
            });
          } else {
            let editRoleData = editFormValues.userRoleMapping.filter(
              (d: any) => d.roleId === role
            );
            editRoleData[0].isDeleted = true;
            userCountryRoleMappings.push(editRoleData[0]);
          }
        }
      });
    }
    return userCountryRoleMappings;
  };

  const closeToasterParticularTimeInterval = () => {
    setTimeout(function () {
      closeToasterFun();
    }, CommonConstant.SHOW_TOSTER_MESSAGE_TIME_INTERVEL);
  };

  const handleSelectRoleChange = ([event]: any, indexArray: any) => {
    let roleMap = roleData.filter(
      (role: any) => role.id === event.target.value
    );

    if (
      roleMap.length &&
      (roleMap[0].name.trim() === NEW_USER.ROLE.ADMIN ||
        roleMap[0].name.trim() === NEW_USER.ROLE.FMC ||
        roleMap[0].name.trim() === NEW_USER.ROLE.INS ||
        roleMap[0].name.trim() === NEW_USER.ROLE.PARTNER ||
        roleMap[0].name.trim() === NEW_USER.ROLE.QMU ||
        roleMap[0].name.trim() === NEW_USER.ROLE.SOLUTION_OWNER ||
        roleMap[0].name.trim() === NEW_USER.ROLE.SOLUTION_TEAM ||
        roleMap[0].name.trim() === NEW_USER.ROLE.UNICEF)
    ) {
      if (roleMap.length && roleMap[0].name.trim() === NEW_USER.ROLE.UNICEF) {
        setIsGuestRoleAdded(true);
        fieldsRegionArray.map((item: any) => {
          if (item.counterRegion === indexArray) {
            item.isVisible = true;
            item.setRoleUser = {
              roleId: event.target.value,
              isSelectable: false,
              name: roleMap[0].name,
              isDeleted: false,
            };
          } else {
            item.isVisible = false;
            item.setRoleUser.isDeleted = true;
          }
        });
        setFieldsRegionArray([...fieldsRegionArray]);
      } else {
        fieldsRegionArray.map((item: any) => {
          //item.isVisible = true;
          if (item.counterRegion === indexArray) {
            item.setRoleUser = {
              roleId: event.target.value,
              isSelectable: false,
              name: roleMap[0].name,
              isDeleted: false,
            };
          }
        });
        setIsGuestRoleAdded(false);
        setFieldsRegionArray([...fieldsRegionArray]);
      }
      setIsAdminChecked(false);
    }
    return event.target.value;
  };

  const handleRegionAppend = () => {
    let values: any = [...fieldsRegionArray];
    values.push({
      countryList: [],
      counterRegion: counterRegion,
      isRoleRequired: true,
      setRoleUser: [],
      roleList: listRoles,
    });
    setFieldsRegionArray(values);
    setCounterRegion((prevCounter: any) => prevCounter + 1);
  };

  const handleRegionRemove = (indexArray: any) => {
    const regArray = fieldsRegionArray.filter(
      (item: any, index: any) => item.counterRegion !== indexArray
    );

    const region = fieldsRegionArray.filter(
      (item: any, index: any) => item.counterRegion === indexArray
    )[0];

    if (
      region &&
      (region.setRoleUser.name === NEW_USER.ROLE.UNICEF ||
        region.setRoleUser.roleName === NEW_USER.ROLE.UNICEF)
    ) {
      setIsGuestRoleAdded(false);
    }

    const values: any = [...regArray];
    setFieldsRegionArray(values);
    setIsAdminChecked(false);
    setIsRemoveClicked(true);
  };

  const handleUserStatusChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const checkStatus = event.target.checked;
    setUserStatus(checkStatus);
    const userStatusLable = checkStatus ? "Active" : "Inactive";
    setUserStatusLabel(userStatusLable);
  };

  const handleRoleChange = (event: any) => {
    const value = event.target.value;
    if (value === UserRoles.QMU
      || value === UserRoles.INS
      || value === UserRoles.Solution_Owner) {
      setValue("accessFor", AccessTypeEnum.BOTH);
      setIsDisableAccessFor(true);
    } else {
      setIsDisableAccessFor(false);
    }
    setValue("role", value);
  };

  return (
    <>
      <FormProvider {...methods}>
        <form>
          <BlueSubHeader>
            <Grid container alignItems="center" justify="flex-end">
              {/* <Grid item>
                <Typography component="strong" className="font-size-14">
                  {"Registration Date"}
                  {": "}
                </Typography>
                <Typography component="span">{createdDate}</Typography>
              </Grid> */}
              {/* {isEdit && (
                <Grid item>
                  <Typography component="strong" className="font-size-14">
                    {"Modified Date"}
                    {": "}
                  </Typography>
                  <Typography component="span">{modifiedDate}</Typography>
                </Grid>
              )} */}
              {/* {isEdit && (
                <Grid item>
                  <Typography component="strong" className="font-size-14">
                    {"Last Modified"}
                    {": "}
                  </Typography>
                  <Typography component="span">{userName}</Typography>
                </Grid>
              )} */}

              <Grid item>
                <GreenFormControlLabel
                  label={userStatusLabel}
                  control={
                    <Switch
                      checked={userStatus}
                      onChange={handleUserStatusChange}
                      name="userStatus"
                    />
                  }
                  className="nomargin"
                />
              </Grid>
            </Grid>
          </BlueSubHeader>
          <BigContainer>

            <UserContainer>
              <Grid container>
                <Grid item xs={11}>
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <Grid container alignItems="center">
                        <Grid item xs={12}>
                          <FormInput
                            name="firstName"
                            // disabled={editFormValues.firstName && isEdit}
                            label={"First Name"}
                            required={true}
                            errorobj={errors}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={4}>
                      <Grid container alignItems="center">
                        <Grid item xs={12}>
                          <FormInput
                            name="lastName"
                            // disabled={editFormValues.lastName && isEdit}
                            label={"Last Name"}
                            required={true}
                            errorobj={errors}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={4}>
                      <Grid container alignItems="center">
                        <Grid item xs={12}>
                          <FormInput
                            name="email"
                            disabled={isEdit}
                            label={"Email"}
                            required={true}
                            errorobj={errors}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={1}>
                  <FormCheckbox
                    name="isActive"
                    label={"Active"}
                    checked={userStatus}
                    //disabled={true}
                    onChange={handleUserStatusChange}
                    //defaultValue={true}
                    color="primary"
                  />
                </Grid>
              </Grid>
            </UserContainer>
            <CustomDevider />
            <UserContainer>
              <Grid container>
                <Grid item xs={4}>
                  <Grid container alignItems="center">
                    <Grid item xs={11}>
                      <FormSelect
                        label="Role"
                        name="role"
                        options={UserRolesList}
                        onChange={handleRoleChange}
                        required={true}
                        errorobj={errors}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid container alignItems="center">
                    <Grid item xs={11}>
                      <FormSelect
                        label="Access for"
                        name="accessFor"
                        disabled={isDisableAccessFor}
                        options={accessTypeData}
                        required={true}
                        errorobj={errors}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </UserContainer>
          </BigContainer>
        </form>
      </FormProvider>

      <CustomDevider />

      <Grid container spacing={2} justify="flex-end" className="padding20">
        <Grid item>
          <DialogButtonDefault
            variant="contained"
            color="default"
            onClick={() => showHideTableAndForm(false)}
          >
            {"Cancel"}
          </DialogButtonDefault>
        </Grid>
        <Grid item>
          {isEdit ? (
            <DialogButtonPrimary
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
            >
              {"Update"}
            </DialogButtonPrimary>
          ) : (
            <DialogButtonPrimary
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
            >
              {"Submit"}
            </DialogButtonPrimary>
          )}
        </Grid>
      </Grid>
    </>
  );
}

export default UserProfileFormComponent;
